let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jMDPp")).then(() => parcelRequire('bFiX9'));